import { omit } from 'ramda';

export const createContact = (args) => {
  const {
    account_holder = undefined,
    account_no = undefined,
    address1 = '',
    address2 = '',
    aim = undefined,
    bank_address = undefined,
    bank_name = undefined,
    birthdate = undefined,
    chat3 = undefined,
    city = '',
    company_legalname = '',
    company_name = '',
    registration = '',
    legal_form = '',
    contact_id = '',
    cost_center = undefined,
    cost_discount_days = undefined,
    cost_discount_percent = undefined,
    cost_due_days = undefined,
    cost_end_of_month_flag = undefined,
    cost_payment_method_id = undefined,
    country = '',
    created = '',
    creditor_no = undefined,
    currency_id = undefined,
    customer_no = undefined,
    date_end = undefined,
    date_start = undefined,
    debitor_no = undefined,
    default_declaration_text1 = undefined,
    default_declaration_text2 = undefined,
    email1 = '',
    email2 = undefined,
    fax1 = undefined,
    fax2 = undefined,
    first_name = undefined,
    formality = undefined,
    gender = undefined,
    iCal_password = undefined,
    iban = undefined,
    invoice_discount_days = undefined,
    invoice_discount_percent = undefined,
    invoice_due_days = undefined,
    invoice_end_of_month_flag = undefined,
    invoice_payment_method_id = undefined,
    language = undefined,
    last_modified = '',
    last_name = undefined,
    main_promoter = undefined,
    mobile1 = undefined,
    mobile2 = undefined,
    nick_name = undefined,
    notes = undefined,
    passport_no = undefined,
    phone1 = '',
    phone2 = '',
    postalcode = '',
    postbox = undefined,
    region = undefined,
    request = undefined,
    skype = undefined,
    sortcode = undefined,
    swift = undefined,
    tax_no = '',
    title = undefined,
    url1 = undefined,
    url2 = undefined,
    url3 = undefined,
    url4 = undefined,
    valid_vat_no_flag = undefined,
    vat_no = '',
    vat_no_confirmed = undefined,
    vat_type_id = undefined,
  } = args;
  return {
    ...args,
    account_holder,
    account_no,
    address1,
    address2,
    aim,
    bank_address,
    bank_name,
    birthdate,
    chat3,
    city,
    legal_form,
    company_legalname,
    company_name,
    registration,
    contact_id,
    cost_center,
    cost_discount_days,
    cost_discount_percent,
    cost_due_days,
    cost_end_of_month_flag,
    cost_payment_method_id,
    country,
    created,
    creditor_no,
    currency_id,
    customer_no,
    date_end,
    date_start,
    debitor_no,
    default_declaration_text1,
    default_declaration_text2,
    email1,
    email2,
    fax1,
    fax2,
    first_name,
    formality,
    gender,
    iCal_password,
    iban,
    invoice_discount_days,
    invoice_discount_percent,
    invoice_due_days,
    invoice_end_of_month_flag,
    invoice_payment_method_id,
    language,
    last_modified,
    last_name,
    main_promoter,
    mobile1,
    mobile2,
    nick_name,
    notes,
    passport_no,
    phone1,
    phone2,
    postalcode,
    postbox,
    region,
    request,
    skype,
    sortcode,
    swift,
    tax_no,
    title,
    url1,
    url2,
    url3,
    url4,
    valid_vat_no_flag,
    vat_no,
    vat_no_confirmed,
    vat_type_id,

    contact_type: getContactType(args),
  }

};


export const createInvoiceContact = (args) => {
  const {
    tax_regime,
    tax_regime_code,
    bank_postalcode,
    bank_city,
    bank_country,
    intermediate_country,
    bank_routing
  } = args;
  const contact = createContact(args);
  return {
    ...contact,
    tax_regime,
    tax_regime_code,
    bank_postalcode,
    bank_city,
    bank_country,
    intermediate_country,
    bank_routing,

    new_contact_name: getName(contact),

    payment_provider_data: {
      international_bank_infos: {
        bank_postalcode,
        bank_city,
        bank_country,
        intermediate_country,
        bank_routing,
      }
    },
  }
}

const NEW_CONTACT_ID = 'NEW_CONTACT';
const isNewContact = (contact = createContact()) => contact.contact_id == NEW_CONTACT_ID;
const createNewContact = (args = createContact()) => createContact({ contact_id: NEW_CONTACT_ID, ...args });


const getContactType = ({ company_name, company_legalname, first_name, last_name, registration, legal_form }) => {
  if (company_name || company_legalname) {
    return ContactTypes.Company;
  } else if (first_name || last_name) {
    return ContactTypes.Individual;
  }
  return ContactTypes.Company;
}


const isIndividual = (contact) => getContactType(contact) == ContactTypes.Individual;
const isNotIndividual = (contact) => getContactType(contact) != ContactTypes.Individual;
const isCompany = (contact) => getContactType(contact) == ContactTypes.Company;
const isNotCompany = (contact) => getContactType(contact) != ContactTypes.Company;

const companyKeys = ['company_name', 'company_legalname', 'legal_form'];
const omitCompanyKeys = omit(companyKeys);

const individualKeys = ['first_name', 'last_name'];
const omitIndividualKeys = omit(individualKeys);

const omitByType = (contact = createContact()) => {
  // console.log(isIndividual(contact), omitCompanyKeys(contact));

  if (isIndividual(contact)) {
    return omitCompanyKeys;
  }
  else if (isCompany(contact)) {
    return omitIndividualKeys;
  } else {
    return omit([]);
  }
}

const getName = (contact = createContact()) =>
  getContactType(contact) === ContactTypes.Company
    ? `${contact.company_name || contact.company_legalname || ''}`
    : ((contact.first_name || contact.last_name) ? `${contact.first_name || ''} ${contact.last_name || ''}` : '')

const nameExists = (contact = createContact()) => getName(contact).length > 0;

const ContactTypes = {
  Individual: 'Individual',
  Company: 'Company',
};

const getContactInfo = (contact) => {
  return `
${nameExists(contact) ? `<a 
class="ut-link ut-text-sm ut-text-accent5"
href="#/main/contacts/contact_list/${contact.contact_id}/overview">${getName(contact)}</a><br>` : ''}

${contact.address1 ? `${contact.address1}<br>` : ''}
${contact.city ? `${contact.city}<br>` : ''}
${contact.postalcode ? `${contact.postalcode}<br>` : ''}
${contact.country ? `${contact.country}<br>` : ''}
${contact.vat_no ? `${contact.vat_no}<br>` : ''}
<br>
${contact.phone1 ? `${contact.phone1}<br>` : ''}
${contact.phone2 ? `${contact.phone2}<br>` : ''}
<br>
${contact.email1 ? `<b><a href=mailto:${contact.email1}>${contact.email1}</a></b><br>` : ''}
`;
}
const getPromoterInfo = (contact, promoter_id) => {
  return `
${nameExists(contact) ? `<a 
onClick="e => e.stopPropagation()"
class="ut-link ut-text-sm ut-text-accent5"
href="#/main/booking/promoters/${promoter_id}/overview">${getName(contact)}</a><br>` : ''}

${contact.address1 ? `${contact.address1}<br>` : ''}
${contact.city ? `${contact.city}<br>` : ''}
${contact.postalcode ? `${contact.postalcode}<br>` : ''}
${contact.country ? `${contact.country}<br>` : ''}
${contact.vat_no ? `${contact.vat_no}<br>` : ''}
<br>
${contact.phone1 ? `${contact.phone1}<br>` : ''}
${contact.phone2 ? `${contact.phone2}<br>` : ''}
<br>
${contact.email1 ? `<b><a href=mailto:${contact.email1}>${contact.email1}</a></b><br>` : ''}
`;
}

export const ContactFuncs = {
  createContact,
  createInvoiceContact,
  isNewContact,
  createNewContact,

  getContactType,

  isIndividual,
  isNotIndividual,
  isCompany,
  isNotCompany,

  getName,
  ContactTypes,

  companyKeys,
  omitCompanyKeys,
  individualKeys,
  omitIndividualKeys,
  omitByType,
  getContactInfo,
  getPromoterInfo,
}

